const colors = {
    // primary: 'linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%)',
    primary:'linear-gradient(to right, #ff00cc, #333399)',
    secondary: '#FF4500',
    white: '#FFFFFF',
    black: '#000000',
}

export default colors;